import React from "react";

interface CrossIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const CrossIcon: React.FC<CrossIconProps> = ({
  size = 22,
  color = 'currentColor',
  className,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M5.37109 16.114L16.1137 5.37141"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.1137 16.1139L5.37109 5.37131"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CrossIcon;
